<div class="flex min-h-screen items-center justify-center px-4 py-8">
  <div class="flex w-full max-w-md flex-col gap-6">
    <app-logo [widthInPx]="120" />

    <div hlmCard>
      <div hlmCardHeader>
        <h1 hlmCardTitle>Neues Passwort festlegen</h1>
        <p hlmCardDescription>Wähle ein neues Passwort für dein Konto.</p>
      </div>

      <div hlmCardContent class="space-y-6">
        @if (success) {
          <div hlmAlert>
            <ng-icon name="lucideCircleCheck" />
            <p hlmAlertTitle>Passwort zurückgesetzt</p>
            <p hlmAlertDescription>Wir leiten dich jetzt zum Login weiter.</p>
          </div>
        } @else {
          <form [formGroup]="resetForm" (ngSubmit)="onSubmit()" class="flex flex-col gap-6">
            <div hlmField>
              <label hlmFieldLabel for="password">Neues Passwort</label>
              <hlm-input-group class="w-full">
                <input
                  hlmInputGroupInput
                  id="password"
                  [type]="showPassword ? 'text' : 'password'"
                  formControlName="password"
                  autocomplete="new-password"
                  [attr.aria-invalid]="submitted && f['password'].errors ? 'true' : null" />
                <hlm-input-group-addon align="inline-end">
                  <button
                    hlmInputGroupButton
                    type="button"
                    [attr.aria-label]="showPassword ? 'Passwort verbergen' : 'Passwort anzeigen'"
                    (click)="showPassword = !showPassword">
                    <ng-icon [name]="showPassword ? 'lucideEyeOff' : 'lucideEye'" />
                  </button>
                </hlm-input-group-addon>
              </hlm-input-group>
              @if (submitted && f['password'].errors) {
                <p hlmFieldDescription class="text-destructive">
                  Das Passwort muss mindestens 6 Zeichen haben.
                </p>
              }
            </div>

            <div hlmField>
              <label hlmFieldLabel for="confirmPassword">Passwort bestätigen</label>
              <hlm-input-group class="w-full">
                <input
                  hlmInputGroupInput
                  id="confirmPassword"
                  [type]="showConfirmPassword ? 'text' : 'password'"
                  formControlName="confirmPassword"
                  autocomplete="new-password"
                  [attr.aria-invalid]="
                    submitted &&
                    (f['confirmPassword'].errors || resetForm.errors?.['passwordsNotMatching'])
                      ? 'true'
                      : null
                  " />
                <hlm-input-group-addon align="inline-end">
                  <button
                    hlmInputGroupButton
                    type="button"
                    [attr.aria-label]="
                      showConfirmPassword ? 'Passwort verbergen' : 'Passwort anzeigen'
                    "
                    (click)="showConfirmPassword = !showConfirmPassword">
                    <ng-icon [name]="showConfirmPassword ? 'lucideEyeOff' : 'lucideEye'" />
                  </button>
                </hlm-input-group-addon>
              </hlm-input-group>
              @if (submitted && f['confirmPassword'].errors) {
                <p hlmFieldDescription class="text-destructive">Bitte bestätige dein Passwort.</p>
              } @else if (submitted && resetForm.errors?.['passwordsNotMatching']) {
                <p hlmFieldDescription class="text-destructive">
                  Die Passwörter stimmen nicht überein.
                </p>
              }
            </div>

            @if (error) {
              <div hlmAlert variant="destructive">
                <ng-icon name="lucideTriangleAlert" />
                <p hlmAlertTitle>{{ error }}</p>
              </div>
            }

            <button hlmBtn type="submit" class="w-full" [disabled]="loading">
              @if (loading) {
                <hlm-spinner />
                Wird gespeichert…
              } @else {
                Passwort zurücksetzen
              }
            </button>
          </form>
        }

        <p class="text-center text-sm">
          <a routerLink="/login" class="underline underline-offset-4">Zurück zum Login</a>
        </p>
      </div>
    </div>
  </div>
</div>
